/**
 * Écran propre à une clinique (caisse, clôture, trésorerie, stock, achats,
 * dettes fournisseurs, dépenses, boutiques) ouvert depuis « Toutes les
 * cliniques » (ADR 0065) : on demande de choisir une clinique au lieu de
 * montrer en silence celle de la clinique principale. Le serveur refuse de
 * son côté les écritures (409 `account_scope_read_only`).
 */
import { Building2, Layers } from "lucide-react";
import type { ReactNode } from "react";

import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/shared/EmptyState";
import { useSwitchOrg } from "@/features/auth/hooks";

import { useAccessibleOrganisations, useAccountScope } from "../hooks";

export function SingleClinicGuard({ children }: { children: ReactNode }) {
  const allClinics = useAccountScope();
  const accessible = useAccessibleOrganisations();
  const switchOrg = useSwitchOrg();

  if (!allClinics) return <>{children}</>;

  const clinics = accessible.data?.organisations ?? [];
  return (
    <EmptyState
      icon={Layers}
      title="Cet écran se travaille clinique par clinique"
      description="Vous êtes sur « Toutes les cliniques ». Choisissez la clinique à ouvrir."
      className="py-16"
      action={
        <div className="flex flex-wrap justify-center gap-2">
          {clinics.map((o) => (
            <Button
              key={o.id}
              variant="outline"
              size="sm"
              disabled={switchOrg.isPending}
              onClick={() => switchOrg.mutate(o.id)}
            >
              <Building2 className="h-4 w-4" aria-hidden />
              {o.name}
            </Button>
          ))}
        </div>
      }
    />
  );
}
